import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { Calendar } from 'react-multi-date-picker';
import moment from 'moment';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import gregorian_ru from '../RangeDatePicker/gregorian_ru';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import '../RangeDatePicker/RangeDatePickerStyles.scss';

const defaultDateFormat = 'DD.MM.YYYY';

export default function MultipleDatePicker(props) {
  const {
    className = '',
    disabled = false,
    inputProps = {},
    withLabel = false,
    usePortal = true,
    inline = false,
    fieldState = {
      error: '',
      touched: false,
    },
    disableInitialSelect = false,
    notDefaultValue = false,
    withFormat = null,
    changeFormat = null,
    variant = null,
    onChangeToIso = false,
  } = props;

  const { onChange = () => {}, name, value = [] } = inputProps;
  const { error = '', touched = false } = fieldState;
  const pickerRef = useRef(null);
  const anchorElement = useRef(null);
  const [currentValue, setCurrent] = useState(value || []);
  const [pickerKey, setPickerKey] = useState(0);
  const format = withFormat || defaultDateFormat;
  const cvm = currentValue.map(v => {
    const m = changeFormat ? moment(v, changeFormat) : moment(v);
    return m.isValid() ? m : null;
  }).filter(f => !!f);

  useEffect(() => {
    setCurrent(value || []);
  }, [value]);

  const onSelect = (newValue, initialSelect) => {
    if (!inputProps) {
      return;
    }
    if (initialSelect && (disableInitialSelect || notDefaultValue)) {
      return;
    }
    const dates = newValue.map(d => (d && d.isValid ? d.toDate() : null)).filter(f => !!f);
    setCurrent(dates.map(d => d.toString()));

    if (changeFormat) {
      onChange({ target: { value: dates.map(d => moment(d).format(changeFormat)), name } });
    } else if (onChangeToIso) {
      onChange({ target: { value: dates.map(d => (d ? d.toISOString() : '')).filter(f => !!f), name } });
    } else {
      onChange({ target: { value: dates, name } });
    }
    setTimeout(() => {
      setPickerKey(pickerKey + 1);
    }, 50);
  };

  const onReset = event => {
    setCurrent([]);
    onChange({ target: { value: [], name } });
    event.stopPropagation();
  };

  return (
    <div className={classNames('form-control-wrapper date-picker', { 'inline-picker': inline }, className)}>
      <div className="custom-react-date-picker">
        <Dropdown usePortal={usePortal} disabled={disabled}>
          <Dropdown.Toggle className="mini-profile-button">
            <div ref={anchorElement} className="date-selector-wrapper">
              <div className="date-selector">
                <TextInput
                  {...props}
                  readOnly
                  className={classNames('data-picker-text', { 'is-invalid': error && touched })}
                  containerRef={pickerRef}
                  inputProps={{
                    value: cvm ? cvm.map(v => v.format(format)).join(', ') : '',
                  }}
                  withLabel={withLabel}
                  inputAfter={(
                    <div className="search-wrapper">
                      <Icons customIcon className="search" width={21} height={24} icon="calendar" />
                      <Icons customIcon onClick={onReset} width={24} height={24} icon="close" />
                    </div>
                  )}
                  variant={variant}
                />
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu anchorElement={anchorElement} disableClickToggle className="data-picker-wrapper" useResizeContent={false}>
            <Calendar
              key={pickerKey}
              locale={gregorian_ru}
              weekStartDayIndex={1}
              onChange={onSelect}
              value={cvm && cvm.length ? cvm.map(v => v.toDate()) : [new Date()]}
            />
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
